import { useCallback } from 'react';

import ToastComponent, { IToastType } from '../components/Toast/ToastComponent';
import { useEditPintoEbookCollectionMutation } from '../core/graphql/operation-hooks';
import { CreatePintoEbookCollectionInput } from '../core/graphql/types';

const useMutationEditEbookCollection = () => {
  const [mutate, { loading }] = useEditPintoEbookCollectionMutation();

  const editEbookCollection = useCallback(
    async (ebookCollectionId: string, input: CreatePintoEbookCollectionInput) => {
      try {
        const res = await mutate({ variables: { ebookCollectionId, input } });
        if (res.data?.editPintoEbookCollection?._id) {
          return { success: true, data: res.data.editPintoEbookCollection };
        } else {
          ToastComponent({ label: 'Edit failed.', type: IToastType.ERROR });
          return { success: false };
        }
      } catch (err) {
        ToastComponent({ label: 'An error occurred.', type: IToastType.ERROR });
        return { success: false };
      }
    },
    [mutate],
  );

  return { editEbookCollection, isEditing: loading };
};

export default useMutationEditEbookCollection;
